document.addEventListener('DOMContentLoaded', () => {

    const variantImage = document.querySelector('.pdm-nutrition-facts__product-image-wrapper .variant-image');
    const netWeightElem = document.querySelector('.net-weight');
    const ingredients = document.querySelector('.ingredients');
    const tableImage = document.querySelector('.pdm-nutrition-facts_table-image-wrapper img');
    const productVariants = document.querySelector('.product-variant');
    if (productVariants) {
        const varButtons = productVariants.querySelectorAll('.var-button .var-input');
        varButtons.forEach(varButton => {
            varButton.addEventListener('change', (event) => {
                console.log('Variant button clicked');
                console.log('new image is:', event.target.getAttribute('data-image'));
                const newImageUrl = event.target.getAttribute('data-image');
                const newNetWeight = event.target.getAttribute('data-net-weight');
                const newIngredients = event.target.getAttribute('data-ingredients');
                console.log('new ingredients:', newIngredients);
                const newTableImage = event.target.getAttribute('data-table-image');

                if (variantImage) {
                    variantImage.src = newImageUrl;
                };
                if (netWeightElem) {
                    netWeightElem.textContent = newNetWeight;
                };
                if (ingredients) {
                    ingredients.innerHTML = newIngredients;
                }
                if (tableImage) {
                    tableImage.src = newTableImage;
                }
            });
        });
    } else {
        console.warn('No product variants found in the DOM.');
    }
}); 
